// import { useEffect, useState } from "react";

// import "../css/Home.css";

// const slides = [
//   {
//     image: "/assets/images/slider/slider1.jpg",
//     title: "Your Scent Journey Starts Here",
//     subtitle: "Premium Decants • Quick Delivery",
//   },
//   {
//     image: "/assets/images/slider/slider2.jpg",
//     title: "Luxury Fragrance Decants",
//     subtitle: "Premium Decants • Quick Delivery",
//   },
//   {
//     image: "/assets/images/slider/slider3.jpg",
//     title: "Authentic & Trusted",
//     subtitle: "Curated for Perfume Lovers",
//   },
//   {
//     image: "/assets/images/slider/slider4.jpg",
//     title: "Your Scent Journey Starts Here",
//     subtitle: "Curated for Perfume Lovers",
//   },
//   {
//     image: "/assets/images/slider/slider5.jpg",
//     title: "Authentic & Trusted",
//     subtitle: "Premium Decants • Quick Delivery",
//   },
// ];

// function Home() {
//   const [current, setCurrent] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrent((prev) => (prev + 1) % slides.length);
//     }, 5000);

//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div className="hero-slider">
//       {slides.map((slide, index) => (
//         <div
//           key={index}
//           className={`slide ${index === current ? "active" : ""}`}
//           style={{ backgroundImage: `url("${slide.image}")` }}
//         >
//           <div className={`overlay ${index === current ? "animate" : ""}`}>
//             <h1>{slide.title}</h1>
//             <p>{slide.subtitle}</p>
//           </div>
//         </div>
//       ))}
//       <div className="hero-dots">
//         {slides.map((_, index) => (
//           <span
//             key={index}
//             className={`dot ${index === current ? "active" : ""}`}
//             onClick={() => setCurrent(index)}
//           />
//         ))}
//       </div>
//     </div>
//   );
// }

// export default Home;


import { useEffect, useState } from "react";
import "../css/Home.css";
import axiosInstance from "../config";

function Home() {
  const [slides, setSlides] = useState([]);
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSliders();
  }, []);

  const fetchSliders = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get('/user/sliders');
      
      if (response.data.success && response.data.data) {
        const apiSlides = response.data.data.map(slider => ({
          id: slider.id,
          image: slider.image_url
        }));
        
        setSlides(apiSlides);
      } else {
        throw new Error('Failed to fetch sliders: API returned unsuccessful response');
      }
    } catch (err) {
      console.error('Error fetching sliders:', err);
      setError(err.message || 'Failed to load slider images');
      
      setSlides([
        {
          image: "/assets/images/slider/slider1.jpg",
        },
        {
          image: "/assets/images/slider/slider2.jpg",
        },
        {
          image: "/assets/images/slider/slider3.jpg",
        },
        {
          image: "/assets/images/slider/slider4.jpg",
        },
        {
          image: "/assets/images/slider/slider5.jpg",
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (slides.length > 0) {
      const interval = setInterval(() => {
        setCurrent((prev) => (prev + 1) % slides.length);
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [slides]);

  if (loading) {
    return (
      <div className="hero-slider loading">
        <div className="d-flex justify-content-center align-items-center" style={{ height: '500px' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (slides.length === 0 && !error) {
    return (
      <div className="hero-slider empty">
        <div className="alert alert-info m-3" role="alert">
          No slider images available
        </div>
      </div>
    );
  }

  if (error && slides.length === 0) {
    return (
      <div className="hero-slider error">
        <div className="alert alert-warning m-3" role="alert">
          {error}
        </div>
      </div>
    );
  }

  return (
    <div className="hero-slider">
      {slides.map((slide, index) => (
        <div
          key={slide.id || index}
          className={`slide ${index === current ? "active" : ""}`}
        >
          <img 
            src={slide.image} 
            alt={`Slider ${index + 1}`}
            className="slide-image"
            onError={(e) => {
              e.target.src = "/assets/images/slider/slider1.jpg";
            }}
          />
          <div className={`overlay ${index === current ? "animate" : ""}`}>
            <h1>{slide.title}</h1>
            <p>{slide.subtitle}</p>
          </div>
        </div>
      ))}
      <div className="hero-dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === current ? "active" : ""}`}
            onClick={() => setCurrent(index)}
          />
        ))}
      </div>
    </div>
  );
}

export default Home;